let lastFaviconHref: string | null = null;

export const setFavicon = (href?: string | null) => {
  const head = document.head;
  if (!head) return;

  const targetHref = href || '/favicon/favicon.ico';
  if (targetHref === lastFaviconHref) return;
  lastFaviconHref = targetHref;

  // All format-specific favicon <link> tags (PNG, SVG, ICO, apple-touch-icon) end
  // up pointing at the same targetHref, so keep a single <link> instead of one per
  // tag — otherwise the browser fetches the same image once per tag on every change.
  const links = head.querySelectorAll<HTMLLinkElement>(
    'link[rel~="icon"], link[rel="shortcut icon"], link[rel="apple-touch-icon"]'
  );

  if (links.length > 0) {
    const [primary, ...rest] = Array.from(links);
    primary.rel = 'icon';
    primary.href = targetHref;
    rest.forEach((link) => link.remove());
    return;
  }

  const link = document.createElement('link');
  link.rel = 'icon';
  link.href = targetHref;
  head.appendChild(link);
};
